import React, { createContext, useContext } from "react";

interface CuadraWidgetContextType {
  currentModelId: string | null;
  models: Array<{ id: string; name: string }>;
  modelsLoading: boolean;
  modelsError: Error | null;
  onModelChange: (modelId: string) => void;
  refetchModels: () => void;
}

const CuadraWidgetContext = createContext<CuadraWidgetContextType | undefined>(
  undefined,
);

export const useCuadraWidgetContext = () => {
  const context = useContext(CuadraWidgetContext);
  if (!context) {
    throw new Error(
      "useCuadraWidgetContext must be used within CuadraWidgetProvider",
    );
  }
  return context;
};

interface CuadraWidgetProviderProps {
  children: React.ReactNode;
  value: CuadraWidgetContextType;
}

export const CuadraWidgetProvider: React.FC<CuadraWidgetProviderProps> = ({
  children,
  value,
}) => {
  return (
    <CuadraWidgetContext.Provider value={value}>
      {children}
    </CuadraWidgetContext.Provider>
  );
};
